<template>
  <div class="course-detail">
    <div class="online-course">
      <course-player ref="coursePlayer" v-if="courseCategoryData && courseCategoryData.length > 0"
                     :current-video="currentVideo" class="course-player" :last-video-id="lastVideoId"
                     :courseEvaluateList="courseEvaluateList" :video-list="courseCategoryData"
                     @timeupdate="handleTimeUpdate"></course-player>
      <van-image class="img-course-poster" fit="cover" v-else-if="courseData.coverMaterial"
                 :src="courseData && courseData.coverMaterial.url">
      </van-image>
      <div class="flex-title flex-two">
        <div class="item-txt">播放量：{{ courseData.playNum ? courseData.playNum : 0 }}</div>
        <div class="items-con">
          <div class="block-flex" @click="handleCollectCourse">
            <img src="@/assets/images/common/icon-collet.png" v-if="courseData && courseData.myCollect" class="icon-block" alt="">
            <img src="@/assets/images/common/icon-colleted.png" v-else class="icon-block" alt="">
            <div class="block-flex-txt">{{ courseData && courseData.collectNum }}</div>
          </div>
          <div class="block-flex" @click="handleLikeCourse">
            <img src="@/assets/images/common/icon-like.png" v-if="courseData && courseData.myLike" class="icon-block" alt="">
            <img src="@/assets/images/common/icon-liked.png" v-else class="icon-block" alt="">
            <div class="block-flex-txt">{{ courseData && courseData.likeNum }}</div>
          </div>
          <div class="block-flex" v-if="`${courseData.state}` === '1' && isAnswer !== 2" @click="handleQuestion">
            <img src="@/assets/images/grade/img3.png" v-if="isAnswer === 1" class="img-question" alt="">
            <img src="@/assets/images/grade/img1.png" v-else class="img-question" alt="">
          </div>
        </div>
      </div>
      <div class="flex-title flex-top">
        <div class="title-txt" :class="itemtxt === 0 ? 'cur' : ''" @click="handleClickItems(0)">
          课程介绍
          <img src="@/assets/images/home/underline@2x.png" v-if="itemtxt === 0" class="cur-icon" alt="">
        </div>
        <div class="title-txt" :class="itemtxt === 1 ? 'cur' : ''" @click="handleClickItems(1)">
          相似推荐
          <img src="@/assets/images/home/underline@2x.png" v-if="itemtxt === 1" class="cur-icon" alt="">
        </div>
        <div v-if="showCourseMaterials" class="title-txt" :class="itemtxt === 2 ? 'cur' : ''" @click="handleClickItems(2)">
          课件推荐
          <img src="@/assets/images/home/underline@2x.png" v-if="itemtxt === 2" class="cur-icon" alt="">
        </div>
      </div>
      <template v-if="itemtxt === 0">
        <div class="course-intro">
          <div class="video-dot-list" v-if="currentVideo.dotList && currentVideo.dotList.length">
            <div class="header">
              <div class="title">课程知识点</div>
              <div class="header-right">
                (<i>{{ isCurDotIndex }}</i>/{{ currentVideo && currentVideo.dotList.length }}个知识点)
              </div>
            </div>
            <div class="cont">
              <div class="dot-list"
                   @touchstart.stop="handleTouchStart"
                   @touchend.stop="handleTouchEnd"
                   @scroll.stop="handleScroll"
              >
                <div
                  v-for="(item, index) in currentVideo.dotList"
                  :key="index"
                  class="dot-item"
                  v-track="{ functionName: `${item.knowledge}` }"
                  :class="item.isCurrent ? 'cur':''"
                  @click.stop="changeDotTime(item)"
                >
                  <div class="dot-item-cont">
                    <div class="dot-icon">
                      <img src="../../assets/images/course/dot-icon.png" alt="" v-if="!item.isCurrent">
                      <img src="../../assets/images/course/dot-icon-active.png" alt="" v-else>
                    </div>
                    <div class="dot-title">
                      <span class="name">{{ item && item.knowledge }}</span>
                      <span class="time">{{ item && item.startTime }} - {{ item && item.endTime }}</span>
                    </div>
                  </div>
                  <div class="dot-line"></div>
                </div>
              </div>
            </div>
          </div>
          <course-summary v-if="currentVideo && currentVideo.summary" :currentVideo="currentVideo"></course-summary>
          <base-card class="expert-card">
            <div class="course-name">{{ courseData && courseData.name }}</div>
            <!-- <div class="item-txt">播放量：{{ courseData.playNum ? courseData.playNum : 0 }}</div> -->
            <template v-if="courseData.courseLecturers &&
              courseData.courseLecturers.length
              ">
              <div class="expert-content" v-for="(expert, eIdx) of courseData.courseLecturers" :key="expert + eIdx">
                <template v-if="eIdx === 0">
                  <div class="teacher-con">
                    <div class="teacher-info">
                      <van-image class="head-portrait" v-if="expert && expert.headPic" :src="expert && expert.headPic.url"
                                 :loading-icon="iconUserHeadDefault" :error-icon="iconUserHeadDefault" round
                                 fit="cover"/>
                      <div class="content">
                        <div class="name">{{ expert && expert.name }}</div>
                        <div class="title">{{ expert && expert.title }}</div>
                        <div class="hospital-name">
                          {{ expert && expert.hospitalName }}
                        </div>
                        <!--<div class="hospital">{{ expert.summary }}</div>-->
                      </div>
                    </div>
                    <div v-if="!teacherShow && expert.summaryText && expert.summaryText != ''
                      " class="watch-more" @click="teacherShow = !teacherShow">
                      <div class="txt">更多</div>
                      <img width="12" height="7" class="down-arrow"
                           src="../../assets/images/course/icon-arrowDown.png"/>
                    </div>
                  </div>
                  <div v-if="teacherShow && expert.summaryText && expert.summaryText != ''" class="summary">
                    <div class="conTxt" v-html="expert.summaryText"/>
                    <div class="watch-more" @click="teacherShow = !teacherShow">
                      <div class="txt">收起</div>
                      <img width="12" height="7" class="down-arrow" src="../../assets/images/course/icon-arrowUp.png"/>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </base-card>
        </div>
        <course-category :course-category-data="courseCategoryData" @switchTask="handleSwitchTask"></course-category>
        <course-introduction :introduction="courseIntroductionUrl"></course-introduction>
        <course-evaluate-list :evaluateList="courseEvaluateList"></course-evaluate-list>
      </template>
      <template v-else-if="itemtxt === 2 && showCourseMaterials">
        <div class="course-material-con">
          <div
            class="material-item"
            v-for="(item, index) in courseMaterials"
            :key="item.id || item.materialId || index"
            @click="handleCourseMaterialClick(item)"
          >
            <div class="material-info">
              <div class="material-title">{{ getCourseMaterialTitle(item) }}</div>
              <div v-if="isCaseMaterial(item) && getCaseMaterialHospital(item)" class="material-meta">
                医院：{{ getCaseMaterialHospital(item) }}
              </div>
              <div v-if="isCaseMaterial(item) && getCaseMaterialAuthor(item)" class="material-meta-row">
                <span>作者：{{ getCaseMaterialAuthor(item) }}</span>
              </div>
            </div>
            <div class="material-cover-wrap">
              <img :src="getCourseMaterialCover(item)" class="material-cover" alt="">
              <div class="material-type-tag">
                <img :src="getCourseMaterialTypeIcon(item.type)" class="tag-icon" alt="">
                {{ getCourseMaterialTypeName(item.type) }}
              </div>
            </div>
          </div>
          <div class="search-none" v-if="courseMaterials.length <= 0">
            <img src="@/assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
            <div class="none-txt">暂无内容</div>
          </div>
        </div>
      </template>
      <template v-else-if="itemtxt === 1">
        <div class="recomm-con">
          <div class="flex-title">
            <div class="title-txt" :class="itemRecomm === 2 ? 'cur' : ''" @click="handleClickRecommItems(2)">
              课程
              <img src="@/assets/images/home/underline@2x.png" v-if="itemRecomm === 2" class="cur-icon" alt="">
            </div>
            <div class="title-txt" :class="itemRecomm === 3 ? 'cur' : ''" @click="handleClickRecommItems(3)">
              病例
              <img src="@/assets/images/home/underline@2x.png" v-if="itemRecomm === 3" class="cur-icon" alt="">
            </div>
            <div class="title-txt" :class="itemRecomm === 1 ? 'cur' : ''" @click="handleClickRecommItems(1)">
              文献
              <img src="@/assets/images/home/underline@2x.png" v-if="itemRecomm === 1" class="cur-icon" alt="">
            </div>
          </div>
          <van-list v-model="loading" v-if="list.length > 0 && !isNone" :finished="finished"
                    finished-text="我是有底线的" loading-text="正在加载..." @load="onLoad" class="cons-list">
            <div class="flex-con" v-for="(item, index) in list" :key="index" @click="handleDialogUnlock(item)">
              <div class="left-con">
                <div class="txt1" :class="itemRecomm === 1 ? 'docu' : ''">{{ item.title }}</div>
                <div class="txt2" v-if="itemRecomm === 3">
                  <span class="span1">作者：{{ item.keynoteSpeaker }}</span>
                  <!-- <span class="span2">播放量:{{ item.readNum }}</span> -->
                </div>
                <div class="txt2" v-if="itemRecomm === 2">
                  <span class="span1">讲师：{{ item.keynoteSpeaker }}</span>
                  <div class="item-unlock" v-if="`${item.isUnlock}` === '1' && !item.myUnlock">
                    <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
                    <span class="txt">{{ item.unlockCost }}积分解锁</span>
                  </div>
                  <!-- <span class="span2">播放量:{{item.readNum}}</span> -->
                </div>
                <div class="txt2" v-if="itemRecomm === 1">
                  <span class="span1"></span>
                  <!-- <span class="span2">播放量:{{item.readNum}}</span> -->
                </div>
              </div>
              <div class="right-con">
                <img :src="item.coverUrl" class="con-cover" alt="">
                <!-- <div class="tag-txt">选修</div> -->
              </div>
            </div>
          </van-list>
          <div class="search-none" v-else-if="list.length <= 0 && isNone">
            <img src="@/assets/images/home/empty_state_none@2x.png" class="none-img" alt="">
            <div class="none-txt">暂无内容</div>
          </div>
        </div>
      </template>
    </div>
    <dialog-unlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialog-unlock>
    <course-material-popup ref="courseMaterialPopup" />
    <returnBack></returnBack>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>

<script>
import BaseCard from '@/components/BaseCard.vue'
import CoursePlayer from './components/CoursePlayer.vue'
import CourseCategory from './components/CourseCategory.vue'
import CourseEvaluateList from './components/CourseEvaluateList.vue'
import CourseIntroduction from './components/CourseIntroduction.vue'
import CourseSummary from './components/CourseSummary.vue'
import iconUserHeadDefault from '@/assets/images/home/teacher-head.png'
import {getDatabaseCoursesDetail, similarRecommend, userCollect, cancelUserCollect} from '../../api/api'
// import { hadnleUpdateVideo } from './components/common'
import {Toast} from 'vant'
import {getShareInfo} from '@/utils/wxShare'
import {setSha, traceClickURL} from '../../utils/util'
import dialogUnlock from '@/components/dialogUnlock.vue'
import returnBack from '../RTCZone/compontents/returnBack.vue'
import {debounce} from '@/utils/util'
import {postLike, cancelLike} from '@/api/zone'
import withRouteTracking from '@/utils/withRouteTracking'
import {handleTraceFunction} from '@/utils/trace'
import {courseQuestionAnswer} from '@/api/grade.js'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'
import {isScorm} from '../../api/scorm'
import CourseMaterialPopup from '@/components/CourseMaterialPopup.vue'

const UserProfile = {
  name: 'course',
  components: {
    BaseCard,
    CoursePlayer,
    CourseCategory,
    CourseEvaluateList,
    CourseIntroduction,
    dialogUnlock,
    returnBack,
    CustomDialog,
    CourseMaterialPopup,
    CourseSummary,
  },
  data() {
    return {
      // 导师信息展开合上
      teacherShow: false,
      // 课程数据
      courseData: {},
      activeCourseId: '',
      courseCategoryData: [],
      // 默认头像
      iconUserHeadDefault,
      currentVideo: {},
      lastVideoId: '',
      courseEvaluateList: {},
      courseIntroductionUrl: '',
      itemtxt: 0,
      itemRecomm: 2,
      list: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 5,
      load: false,
      isNone: false,
      dataDetails: {},
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      },
      isAnswer: 2,
      isCurDotIndex: 0, // 当前播放的知识点索引
      currentTime: 0,
      allowAutoScroll: true,
      touchTimer: null,
      unlockFromCourseMaterial: false,
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '该课程已经下架',
        showCloseIcon: false,
        cancel: () => {
          this.cDialog.close()
        },
        confirm: () => {
          this.cDialog.close()
        },
        close: () => {
          this.cDialog.visible = false
          this.$router.back()
        }
      },
    }
  },
  // 为分享出去的时候埋点准备
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.pathToFrom = {
        to,
        from
      }
    })
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    courseMaterials() {
      return this.getVisibleCourseMaterialList(this.courseData.courseMaterials)
    },
    fromPage() {
      return this.$route.query.fromPage
    },
    isLibraryFromPage() {
      return this.fromPage === 'pfa' || this.fromPage === 'laac'
    },
    libraryPagePrefix() {
      if (this.fromPage === 'pfa') return 'PFA图书馆-'
      if (this.fromPage === 'laac') return 'LAAC图书馆-'
      return ''
    },
    // 搜索入口进来，courseLibraryBound为true的时候显示“课件推荐”
    courseLibraryBound() {
      return this.fromPage === 'search' && this.courseData && this.courseData.courseLibraryBound
    },
    showCourseMaterials() {
      return this.isLibraryFromPage || this.fromPage === 'scan' || this.courseLibraryBound
    }
  },
  watch: {
    '$route'(newval, oldval) {
      const newCourseId = this.getRouteCourseId(newval)
      const oldCourseId = this.getRouteCourseId(oldval)
      if (newCourseId && newCourseId !== oldCourseId) {
        this.loadRouteCourse(newval)
      }
    },
    currentTime() {
      this.updateDotListOrder()
    }
  },
  mounted() {
    const routeCourseId = this.getRouteCourseId()
    const saved = sessionStorage.getItem('coursePageState')
    if (saved) {
      const { courseId, itemtxt, scrollTop } = JSON.parse(saved)
      sessionStorage.removeItem('coursePageState')
      if (courseId === routeCourseId) {
        this.activeCourseId = routeCourseId
        this.itemtxt = itemtxt
        this.init().then(() => {
          this.$nextTick(() => { document.documentElement.scrollTop = scrollTop })
        })
        return
      }
    }
    this.loadRouteCourse(this.$route, { force: true })
  },
  activated() {
    this.loadRouteCourse(this.$route)
  },
  deactivated() {
    this.closeCourseMaterialPopup()
  },
  beforeDestroy() {
    this.closeCourseMaterialPopup()
  },
  methods: {
    getRouteCourseId(route = this.$route) {
      return route && route.query ? route.query.courseId : ''
    },
    resetCourseState() {
      this.closeCourseMaterialPopup()
      this.teacherShow = false
      this.courseData = {}
      this.courseCategoryData = []
      this.currentVideo = {}
      this.lastVideoId = ''
      this.courseEvaluateList = {}
      this.courseIntroductionUrl = ''
      this.itemRecomm = 2
      this.list = []
      this.loading = false
      this.finished = false
      this.pageNum = 1
      this.load = false
      this.isNone = false
      this.dataDetails = {}
      this.isAnswer = 2
      this.isCurDotIndex = 0
      this.currentTime = 0
      this.allowAutoScroll = true
      if (this.touchTimer) {
        clearTimeout(this.touchTimer)
        this.touchTimer = null
      }
      this.unlockFromCourseMaterial = false
      this.cDialog.visible = false
      this.dataProps = {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
      if (this.$refs.dialogUnlock) {
        this.$refs.dialogUnlock.dailogShow = false
      }
    },
    loadRouteCourse(route = this.$route, options = {}) {
      const courseId = this.getRouteCourseId(route)
      if (!courseId) return
      if (!options.force && `${courseId}` === `${this.activeCourseId}`) return

      this.activeCourseId = courseId
      this.resetCourseState()
      if (options.resetTab !== false) {
        this.itemtxt = this.$route.query.fromPage === 'scan' ? 2 : 0
      }
      if (options.resetScroll !== false) document.documentElement.scrollTop = 0
      return this.init()
    },
    _savePageState() {
      sessionStorage.setItem('coursePageState', JSON.stringify({
        courseId: this.getRouteCourseId(),
        itemtxt: this.itemtxt,
        scrollTop: document.documentElement.scrollTop
      }))
    },
    // 手指按下时认为用户开始滚动知识点列表
    handleTouchStart() {
      this.allowAutoScroll = false
    },

    handleScroll(e) {
      this.allowAutoScroll = false
      if (this.touchTimer) {
        clearTimeout(this.touchTimer)
      }
      this.touchTimer = setTimeout(() => {
        this.allowAutoScroll = true
      }, 2000)
    },

    // 手指抬起后一小段时间内仍不允许置顶，防止滑动未结束
    handleTouchEnd() {
      if (this.touchTimer) {
        clearTimeout(this.touchTimer)
      }
      this.touchTimer = setTimeout(() => {
        this.allowAutoScroll = true
      }, 2000)
    },

    getCourseMaterialPopup() {
      if (this.$refs.courseMaterialPopup) return this.$refs.courseMaterialPopup

      const child = this.$children && this.$children[0]
      return child && child.$refs ? child.$refs.courseMaterialPopup : null
    },

    closeCourseMaterialPopup() {
      const popup = this.getCourseMaterialPopup()
      if (popup && popup.closeAll) {
        popup.closeAll()
      }
    },

    beforeRouteLeaveCustom() {
      const child = this.$children && this.$children[0]
      const target = child && child.closeCourseMaterialPopup ? child : this
      target.closeCourseMaterialPopup()
      return new Promise(resolve => {
        target.$nextTick(() => resolve(true))
      })
    },

    updateDotListOrder() {
      const video = this.$refs.coursePlayer && this.$refs.coursePlayer.$refs && this.$refs.coursePlayer.$refs.video
      if (!video || !video.isPlayVideo || !this.currentVideo.dotList) return
      this.isCurDotIndex = 0
      this.currentVideo.dotList.forEach(item => {
        const start = this.parseTimeToSeconds(item.startTime)
        const end = this.parseTimeToSeconds(item.endTime)
        if (this.currentTime >= start && this.currentTime <= end) {
          this.isCurDotIndex = item.index
          this.$set(item, 'isCurrent', true)
        } else {
          this.$set(item, 'isCurrent', false)
        }
      })

      this.$nextTick(() => {
        const parentContainer1 = document.querySelector('.dot-list') // 父容器
        const curDot1 = document.querySelector('.dot-item.cur')
        const parentContainer2 = document.querySelector('.dot-list-fullscreen') // 父容器
        const curDot2 = document.querySelector('.dot-item-fullscreen.cur')
        if (parentContainer1 && curDot1 && this.allowAutoScroll) {
          parentContainer1.scrollTop = curDot1.offsetTop
        }
        if (parentContainer2 && curDot2 && this.allowAutoScroll) {
          parentContainer2.scrollTop = curDot2.offsetTop
        }
      })
    },
    handleTimeUpdate({currentTime}) {
      this.currentTime = currentTime
    },
    changeDotTime(item) {
      localStorage.setItem('functionUrl', `courseId=${this.currentVideo.courseId}&sectionId=${this.currentVideo.id}&knowledgeId=${item.id}`)
      if (!this.$refs.coursePlayer.$refs.video.isPlayVideo) {
        this.$refs.coursePlayer.$refs.video.handleClickItemsVideo()
        setTimeout(() => {
          this.$refs.coursePlayer.$refs.video.player.currentTime(item.knowledgeDuration)
        }, 300)
      } else {
        this.$refs.coursePlayer.$refs.video.player.currentTime(item.knowledgeDuration)
      }
    },
    parseTimeToSeconds(timeStr) {
      const parts = timeStr.split(':').map(Number)
      let hours = 0
      let minutes = 0
      let seconds = 0

      // 根据分割结果的长度判断格式
      if (parts.length === 3) {
        // HH:MM:SS 格式
        [hours, minutes, seconds] = parts
      } else if (parts.length === 2) {
        // MM:SS 格式
        [minutes, seconds] = parts
      } else {
        throw new Error(`Invalid time format: ${timeStr}`)
      }

      return hours * 3600 + minutes * 60 + seconds
    },
    handleAnswer() {
      courseQuestionAnswer({courseId: this.courseData.id}).then(res => {
        this.isAnswer = res.data
      })
    },
    handleCollectCourse: debounce(function () {
      if (this.courseData.myCollect > 0) {
        let parmas = {
          'baseId': this.courseData.id,
          'baseType': '1',
          'userId': this.userInfo.id,
        }
        cancelUserCollect(parmas).then(res => {
          this.$toast('取消收藏')
          this.courseData.myCollect = !this.courseData.myCollect ? 1 : 0
          this.courseData.collectNum--
        })
        return
      }
      let parmas = {
        'baseId': this.courseData.id,
        'baseType': '1',
        'userId': this.userInfo.id,
        'userName': this.userInfo.realName
      }
      userCollect(parmas).then(res => {
        this.$toast('收藏成功')
        this.courseData.myCollect = !this.courseData.myCollect ? 1 : 0
        this.courseData.collectNum++
      })
    }, 500),
    handleLikeCourse: debounce(function () {
      if (this.courseData.myLike > 0) {
        let params = {
          baseId: this.courseData.id,
          userId: this.userInfo.id,
        }
        cancelLike(params).then(() => {
          this.courseData.likeNum--
          this.$toast('取消点赞成功')
          this.courseData.myLike = !this.courseData.myLike ? 1 : 0
        })
        return
      }
      let params = {
        likeId: this.courseData.id,
        likeTitle: this.courseData.name,
        userId: this.userInfo.id,
        cover: this.courseData.coverMaterial && this.courseData.coverMaterial.url ? this.courseData.coverMaterial.url : '',
        kind: 5,
        type: 5
      }
      postLike(params).then(res => {
        this.courseData.likeNum++
        this.courseData.myLike = !this.courseData.myLike ? 1 : 0
        this.$toast('点赞成功')
      })
    }, 500),
    handleQuestion() {
      this.$router.push({
        path: '/gradeQuestion',
        query: {
          courseId: this.$route.query.courseId,
          typePage: 'course',
          entrance: this.$route.query.entrance,
          channel: this.$route.query.channel
        }
      })
      // console.log(111)
      // 用这个1831518547812483074课程id
      // courseQuestion({courseId: '1831518547812483074'}).then(res => {
      //   console.log(res)
      // })
    },
    handleClickItems(index) {
      if (index === 2 && !this.showCourseMaterials) return
      this.itemtxt = index
      if (index === 1) {
        this.pageNum = 1
        this.finished = false
        this.list = []
        this.onLoad()
      }
    },
    getCourseMaterialTitle(item) {
      return item.title || item.name || (item.courseMaterial && item.courseMaterial.title) || (item.material && item.material.title) || ''
    },
    getCourseMaterialCover(item) {
      const defaultCover = require('@/assets/images/defaultImage.png')
      if (!item) return defaultCover

      const coverMaterialUrl = item.coverMaterial && item.coverMaterial.url
      if (Number(item.type) === 5 || Number(item.type) === 6) {
        return coverMaterialUrl || defaultCover
      }

      return item.coverMaterialUrl || item.materialUrl || defaultCover
    },
    getVisibleCourseMaterialList(list) {
      return (list || []).filter(item => item && `${item.title || ''}`.trim())
    },
    isCaseMaterial(item) {
      return Number(item && item.type) === 3
    },
    getCaseMaterialAuthor(item) {
      if (!item) return ''
      const material = item.courseMaterial || item.material || {}
      return item.lecturers || item.keynoteSpeaker || item.author || material.lecturers || material.keynoteSpeaker || material.author || ''
    },
    getCaseMaterialHospital(item) {
      if (!item) return ''
      const material = item.courseMaterial || item.material || {}
      const hospital = item.hospital || material.hospital
      return item.lecturerHospitals || item.hospitalName || material.lecturerHospitals || material.hospitalName || (hospital && (hospital.cnName || hospital.name)) || ''
    },
    getCourseMaterialId(item) {
      return item.materialId || item.baseId || item.id
    },
    getPreviewFileId(item) {
      const material = item.courseMaterial || item.material || item
      return (material && material.fileId) || this.getCourseMaterialId(item)
    },
    getCourseMaterialTypeName(type) {
      const map = { 1: '文献', 3: '病例', 5: '视频', 6: 'PPT', 7: '文章', 8: '图文' }
      return map[type] || ''
    },
    getCourseMaterialTypeIcon(type) {
      const iconMap = {
        1: require('@/assets/images/home/search_view@2x.png'),
        3: require('@/assets/images/home/search_case@2x.png'),
        5: require('@/assets/images/video.png'),
        6: require('@/assets/images/PPT.png'),
        7: require('@/assets/images/journalArticles.png'),
        8: require('@/assets/images/search_course_t.png')
      }
      return iconMap[type] || iconMap[1]
    },
    traceCourseMaterialPreview(item) {
      const type = Number(item && item.type)
      if (type !== 5 && type !== 6 && type !== 8) return

      const traceParams = {
        functionName: `${this.libraryPagePrefix}课程详情-课件推荐-${this.getCourseMaterialTypeName(type)}预览`,
        functionUrl: window.location.href,
        createTime: new Date().getTime(),
        note: (item && item.materialId) || ''
      }
      if (this.isLibraryFromPage) {
        traceParams.serviceId = (item && item.materialId) || ''
        traceParams.campId = this.$route.query.courseId || (item && item.courseId) || this.$route.query.businessId || ''
      }
      handleTraceFunction(traceParams)
    },
    getContentCover(item) {
      const defaultCover = require('@/assets/images/defaultImage2.png')
      if (!item) return defaultCover

      const coverMaterialUrl = item.coverMaterial && item.coverMaterial.url
      if (Number(item.type) === 5 || Number(item.type) === 6) {
        return coverMaterialUrl || defaultCover
      }

      return item.coverMaterialUrl || item.materialUrl || defaultCover
    },
    handleCourseMaterialClick(item) {
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataDetails = item
        this.unlockFromCourseMaterial = true
        this.dataProps.baseId = this.getCourseMaterialId(item)
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      const type = Number(item.type)
      if (type === 5 || type === 6 || type === 8) {
        this.traceCourseMaterialPreview(item)
        const materialId = item.materialId || item.courseMaterial.id
        if (!materialId) {
          this.$toast && this.$toast('文件信息缺失')
          return
        }
        this._savePageState()
        this.$router.push({
          path: '/filePreview',
          query: {
            materialId,
            entrance: '11',
            channel: '11'
          }
        })
        return
      }
      if (item.type === 7) {
        this.$router.push({
          path: '/journalArticle',
          query: {articleId: this.getCourseMaterialId(item),
            businessId: item.courseId,
            entrance: '164',
            channel: '164'}
        })
        return
      }
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {id: this.getCourseMaterialId(item), entrance: '164', channel: '164'}
        })
        return
      }
      if (item.type === 3) {
        const openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        this._savePageState()
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${this.getCourseMaterialId(item)}${openidBindli}&entrance=164&businessChannel=164`
        return
      }
      const url = item.materialUrl || (item.courseMaterial && item.courseMaterial.url) || (item.material && item.material.url)
      if (url) {
        this._savePageState()
        window.location.href = url
      }
    },
    handleClickRecommItems: debounce(function (index) {
      this.itemRecomm = index
      this.pageNum = 1
      this.finished = false
      this.list = []
      this.onLoad()
    }, 400),
    async init(boolEva) {
      const courseId = this.getRouteCourseId()
      if (!courseId) return
      try {
        const res = await getDatabaseCoursesDetail({
          courseId
        })
        if (`${courseId}` !== `${this.getRouteCourseId()}`) return
        if (boolEva) {
          this.courseEvaluateList = res.data.courseFeedbacks && res.data.courseFeedbacks.length > 0 ? res.data.courseFeedbacks[0] : {}
          return
        }
        const courseDetail = res.data || {}
        this.courseData = courseDetail
        if (`${this.courseData.state}` === '2') {
          this.cDialog.visible = true
          return
        }
        if (this.$route.query.tab !== undefined) {
          this.itemtxt = Number(this.$route.query.tab)
        }
        try {
          const {data: isScormCourse, code} = await isScorm(courseId)
          if (`${courseId}` !== `${this.getRouteCourseId()}`) return
          if (code === 0 && isScormCourse) {
            this.$router.replace({
              path: '/scormCourseDetail',
              query: {...this.$route.query}
            })
            return
          }
        } catch (e) {
          console.log(e)
        }
        if (`${courseDetail.isUnlock}` === '1' && !courseDetail.myUnlock && !this.$route.query.campId) {
          this.dataProps.baseId = courseDetail.id
          this.dataProps.unlockCost = courseDetail.unlockCost
          this.dataProps.detailsUnlock = true
          this.$refs.dialogUnlock.dailogShow = true
        }
        window.sessionStorage.setItem('mainId', this.courseData.id)
        window.sessionStorage.setItem('serviceId', this.courseData.id)
        let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : window.sessionStorage.getItem('entrance')
        window.sessionStorage.setItem('entrance', entrance)
        window.sessionStorage.setItem('traceTitle', '课程详情-' + this.courseData.name)
        let desc = ''
        if (this.courseData.courseLecturers.length > 0) {
          desc = `${this.courseData.courseLecturers[0].name} ${this.courseData.courseLecturers[0].title} ${this.courseData.courseLecturers[0].hospitalName}`
        }
        getShareInfo({
          title: this.courseData.name,
          titleTimeLine: this.courseData.name,
          desc: desc,
          link: window.location.href, // modifyURLParam(window.location.href, 'entrance', '20'),
          linkTimeLine: window.location.href, // modifyURLParam(window.location.href, 'entrance', '21'),
          images: this.courseData && this.courseData.coverMaterial ? this.courseData.coverMaterial.url : '',
        })
        if (window.location.href.includes('entrance')) {
          window.sessionStorage.setItem('moduleName', '课程')
        }
        this.courseCategoryData = courseDetail.courseChapters[0].courseSections.map(item => {
          // 视频的poster默认为课程的图片
          item.poster = courseDetail.coverMaterial ? courseDetail.coverMaterial.url : ''
          // 是否可以倍速播放 1可以，2不可以
          item.videoSpeedPlayback = courseDetail.videoSpeedPlayback
          // 谁否可以拖拽 1可以，2不可以
          item.dragFlag = courseDetail.dragFlag
          // watchPassPercent 后台传回来的视频观看到百分之几的时候等于完成
          item.watchPassPercent = courseDetail.watchPassPercent

          if (item.videoMaterial && item.videoMaterial.knowledgeList) {
            item.dotList = item.videoMaterial.knowledgeList.map((dot, index) => {
              dot.index = index + 1
              dot.isCurrent = false
              return dot
            })
          } else {
            item.dotList = []
          }
          if (this.$route.query.sectionId && this.$route.query.sectionId === item.id) {
            item.learningStatus = '2'
            this.currentVideo = item
            this.handleSwitchTask(this.currentVideo)
          } else if ((item.learningStatus === '2' || item.learningStatus === '3' || !item.learningStatus) && Object.keys(this.currentVideo) && Object.keys(this.currentVideo).length <= 0) {
            item.learningStatus = '2'
            this.currentVideo = item
            this.handleSwitchTask(this.currentVideo)
          }
          return item
        })
        this.lastVideoId = this.courseCategoryData[this.courseCategoryData.length - 1].id
        this.courseEvaluateList = courseDetail.courseFeedbacks && courseDetail.courseFeedbacks.length > 0 ? courseDetail.courseFeedbacks[0] : {}
        this.courseIntroductionUrl = courseDetail.posterData && courseDetail.posterData.url ? courseDetail.posterData.url : ''
        if (Object.keys(this.currentVideo) && Object.keys(this.currentVideo).length <= 0) {
          this.currentVideo = this.courseCategoryData[0]
        }
        this.handleAnswer()
        this.$nextTick(() => {
          if (this.$route.query.knowledgeDuration) {
            if (!this.$refs.coursePlayer.$refs.video.isPlayVideo) {
              this.$refs.coursePlayer.$refs.video.handleClickItemsVideo()
              setTimeout(() => {
                this.$refs.coursePlayer.$refs.video.player.currentTime(this.$route.query.knowledgeDuration)
              }, 300)
            } else {
              this.$refs.coursePlayer.$refs.video.player.currentTime(this.$route.query.knowledgeDuration)
            }
          }
        })
      } catch (e) {
        Toast('当前id没有内容，请联系管理员添加')
      }
    },
    handleSwitchTask(task) {
      this.currentVideo = task
      // hadnleUpdateVideo(this.currentVideo)
    },

    onLoad() {
      if (this.load) {
        return
      }
      this.load = true
      let params = {
        type: this.itemRecomm,
        contentId: this.$route.query.courseId,
        openId: this.userInfo.iepOpenId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        sectionId: this.currentVideo.id
      }
      similarRecommend(params).then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.list.length <= 0) {
          this.isNone = true
        } else {
          this.isNone = false
        }
        this.pageNum++
      })
    },

    handleDialogUnlock(item) {
      this.dataDetails = item
      this.unlockFromCourseMaterial = false
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleJump()
    },

    async handleJump() {
      let item = this.dataDetails
      if (this.unlockFromCourseMaterial) {
        this.unlockFromCourseMaterial = false
        this.$set(item, 'myUnlock', 1)
        this.handleCourseMaterialClick(item)
        return
      }
      let trackParams = `&entrance=4&businessChannel=4`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            entrance: '4',
            channel: '4'
          }
        })
        // setTimeout(() => { traceClickURL() })
        // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.baseId}${openid}${iepTxt}${trackParams}`
      } else if (item.type === 7) {
        this.$router.push({
          path: '/journalArticle',
          query: {articleId: this.getCourseMaterialId(item)}
        })
      } else if (item.type === 3) {
        setTimeout(() => {
          traceClickURL()
        })
        let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        window.sessionStorage.setItem('entrance', '4')
        const query = {
          courseId: item.baseId,
          sectionId: item.sectionId,
          entrance: '4',
          channel: '4',
        }
        const {data: isscorm, code} = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (code === 0 && isscorm) {
          path = '/scormCourseDetail'
        }
        this.$router.replace({path, query}).then(() => {
          window.location.reload()
        })
      }
    },
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.course-detail {
  padding-bottom: 20px;
  min-height: 100vh;
  background-color: rgb(247, 248, 250);

  .online-course {
    padding-top: 200px;

    /deep/ .van-tabs__line {
      width: 24px;
      height: 2px;
      background: #EB1700;
    }

    .course-player,
    .img-course-poster {
      top: 0;
      left: 0;
      position: fixed;
      z-index: 100;
      width: 375px;
      height: 200px;

      .course-play-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
      }
    }

    .course-intro {
      padding: 104px 12px 0;

      .course-name {
        font-size: 15px;
        font-weight: bold;
        color: #1f333f;
      }

      .item-txt {
        font-size: 12px;
        color: #B8B8B8;
        font-weight: 500;
        line-height: 17px;
        margin-top: 3px;
      }

      .expert-card {
        .expert-content {
          padding: 15px 0 0;

          .teacher-con {
            display: flex;
            align-items: flex-end;
          }

          .teacher-info {
            display: flex;
            align-items: center;
            flex: 1;

            .head-portrait {
              flex-shrink: 0;
              width: 55px;
              height: 55px;
              border-radius: 50%;

              /deep/ .van-icon__image {
                width: 100%;
                height: 100%;
              }
            }

            .content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin: 0 12px;

              .name {
                font-size: 14px;
                font-weight: bold;
                color: #1f333f;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .title {
                font-size: 12px;
                color: #6d6d6d;
                margin: 2px 0;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .hospital-name {
                font-size: 12px;
                color: #6d6d6d;
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .hospital {
                margin-top: 10px;
                margin-left: 2px;
                font-size: 12px;
                font-weight: 500;
                color: #a1adb9;
              }
            }
          }

          .summary {
            margin-top: 17px;
            padding-top: 20px;
            padding-bottom: 7px;
            border-top: 1px solid #eeeeee;

            .conTxt {
              font-size: 13px;
              font-weight: 500;
              color: #666666;
              padding-bottom: 20px;
            }

            .watch-more {
              justify-content: flex-end;
            }
          }

          .watch-more {
            display: flex;
            align-items: center;
            padding-right: 6px;
            width: 60px;

            .txt {
              font-size: 12px;
              font-weight: 500;
              color: #1f333f;
              margin-right: 6px;
            }

            img {
              width: 12px;
              height: 7px;
            }
          }
        }
      }

    }

  }

  .video-dot-list {
    box-sizing: border-box;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    margin-bottom: 10px;
    border-radius: 12px;

    .header {
      display: flex;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      height: 40px;

      .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 15px;
        color: #22323E;
      }

      .header-right {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #5F5F5F;

        i {
          font-style: normal;
          color: #EB1700;
        }
      }
    }

    .cont {
      box-sizing: border-box;
      padding: 5px 15px 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .dot-list {
        height: 110px;
        overflow-y: auto;
        padding-right: 16px;
        margin-right: -16px;
        box-sizing: border-box;
        position: relative;

        .dot-item {
          cursor: pointer;
          position: relative;
          margin-bottom: 10px;

          .dot-item-cont {
            display: flex;
            align-items: flex-start;

            .dot-icon {
              margin-right: 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 6px;

              img {
                width: 6px;
              }
            }

            .dot-title {
              display: flex;
              align-items: flex-start;
              flex: 1;

              .time {
                font-family: PingFang HK, PingFang HK;
                font-weight: 400;
                font-size: 12px;
                color: #B1B1B1;
                margin-top: 2px;
              }

              .name {
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #5F5F5F;
                flex: 1;
              }
            }
          }

          &:last-child {
            height: auto;
            margin-bottom: 0;

            .dot-line {
              display: none;
            }
          }

          .dot-line {
            position: absolute;
            top: 14px;
            left: 2px;
            width: 2px;
            height: 100%;
            border-radius: 10px;
            background: url("~@/assets/images/course/dot-line.png") no-repeat center center / 100% 100%;
          }

          &.cur {
            .dot-item-cont {
              .dot-title {
                .time {
                  color: #EB1700;
                }

                .name {
                  color: #EB1700;
                }
              }
            }
          }
        }
      }

      .course-summary {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #5F5F5F;

        span {
          font-weight: 500;
          color: #2B2B2B;
        }
      }
    }
  }

  .flex-title {
    display: flex;
    align-items: center;
    background-color: #fff;
    position: fixed;
    width: 100%;
    left: 0;
    z-index: 99;
    height: 48px;

    &.flex-top {
      top: 248px;
      padding-right: 124px;
      box-sizing: border-box;

      .title-txt {
        min-width: 0;
      }
    }

    &.flex-two {
      top: 200px;
      justify-content: space-between;
      padding: 0 14px;
      box-sizing: border-box;

      .items-con {
        display: flex;
        align-items: center;

        .block-flex {
          display: flex;
          align-items: center;
          margin-left: 20px;

          .icon-block {
            width: 22px;
            height: 22px;
            display: block;
            margin-right: 4px;
          }

          .block-flex-txt {
            color: #323232;
            font-family: PingFang HK, PingFang HK;
            font-size: 14px;
          }

          .img-question {
            width: 78px;
            margin-right: -15px;
          }
        }
      }
    }

    .title-txt {
      flex: 1;
      text-align: center;
      line-height: 40px;
      font-size: 15px;
      color: #6A7481;

      .cur-icon {
        width: 23px;
        height: 10px;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }

      &.cur {
        color: #EB1700;
        position: relative;
        font-weight: 500;
      }
    }
  }

  .recomm-con {
    margin: 110px 12px 0;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    padding-bottom: 1px;
    box-sizing: border-box;
    border-radius: 12px;
    position: relative;

    /deep/ .van-list__finished-text, /deep/ .van-list__loading {
      position: absolute;
      bottom: -60px;
      text-align: center;
      width: 100%;
    }

    .flex-title {
      position: static;
      padding: 0 30px;
      box-sizing: border-box;
      margin-bottom: 10px;
      border-radius: 12px 12px 0 0;

      .title-txt {
        color: #5B5F6A;

        &.cur {
          font-weight: 500;
          color: #000000;
        }
      }
    }

    .flex-con {
      display: flex;
      justify-content: space-between;
      padding: 0 12px;
      box-sizing: border-box;
      margin-bottom: 25px;
      align-items: center;

      .right-con {
        width: 110px;
        height: 60px;
        position: relative;
        border-radius: 5px;
        overflow: hidden;

        .con-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .tag-txt {
          position: absolute;
          width: 30px;
          height: 16px;
          font-size: 10px;
          background-color: #6A7481;
          border-radius: 5px;
          left: 0;
          top: 0;
          text-align: center;
          line-height: 16px;
          color: #fff;
          font-size: 10px;
        }
      }

      .left-con {
        .txt1 {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          line-height: 20px;
          margin-bottom: 8px;
          width: 200px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;

          &.docu {
            height: 40px;
            white-space: inherit;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .txt2 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #B1B1B1;
          font-size: 12px;

          .item-unlock {

            .icon-unlock {
              width: 10px;
            }

          }
        }
      }
    }

    .search-none {
      padding-bottom: 40px;
      box-sizing: border-box;

      .none-img {
        width: 185px;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 50px;
      }

      .none-txt {
        font-size: 12px;
        color: #949BA5;
        text-align: center;
        margin-top: 10px;
      }
    }
  }

  .course-material-con {
    margin: 110px 10px 0;
    padding: 8px 10px 6px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 2px 12px 0 rgba(31, 51, 63, 0.08);

    .material-item {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      min-height: 92px;
      padding: 14px 6px;
      box-sizing: border-box;
    }

    .material-info {
      flex: 1;
      min-width: 0;
      margin-right: 18px;
    }

    .material-title {
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      color: #000;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }

    .material-meta,
    .material-meta-row {
      margin-top: 4px;
      font-size: 12px;
      line-height: 18px;
      color: #949BA5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .material-meta-row {
      margin-top: 2px;
    }

    .material-cover-wrap {
      position: relative;
      flex: 0 0 128px;
      width: 128px;
      height: 70px;
      border-radius: 6px;
      overflow: hidden;
      background: #f6f6f6;
    }

    .material-cover {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }

    .material-type-tag {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      gap: 3px;
      padding: 2px 5px;
      border-radius: 6px 6px 6px 0;
      background: rgba(0, 0, 0, 0.55);
      color: #fff;
      font-size: 10px;
      line-height: 14px;

      .tag-icon {
        width: 11px;
        height: 11px;
        object-fit: contain;
      }
    }

    .search-none {
      padding-bottom: 40px;
      box-sizing: border-box;

      .none-img {
        width: 185px;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-top: 50px;
      }

      .none-txt {
        font-size: 12px;
        color: #949BA5;
        text-align: center;
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/course/course.vue